import React, { useContext } from 'react';

import { useQuery } from '@apollo/client';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { DEFAULT_DISCOVER_URL } from '../../../../const';
import { DiscoverContext } from '../../../../context/DiscoverContext';
import { GET_HAS_NEWS } from '../../../../graphql/local';
import styled from '../../../../styled';
import { MIDDLE_MARGIN_PX, SMALL_MARGIN_PX } from '../../../../theme';
import { HITS_TYPES } from '../../../const';
import { TabItem } from '../TabItem';

interface TabsProps {
  selectedItem?: string;
  refine?: Function;
}

const Tabs: React.FC<TabsProps> = ({ selectedItem, refine }) => {
  const { t } = useTranslation();

  const { searchState } = useContext(DiscoverContext);
  const searchQuery = searchState?.query || '';

  const { data } = useQuery(GET_HAS_NEWS);
  const hasNews = data?.hasNews;

  return (
    <Wrapper>
      <TabItem
        data-testid="allTab"
        value=""
        label={t('page.discover.all')}
        selectedItem={selectedItem}
        handleSelect={refine}
        link={`${DEFAULT_DISCOVER_URL}/search${searchQuery ? '?s=' + searchQuery : ''}`}
      />
      <TabItem
        data-testid="videosTab"
        label={t('page.discover.videoModules')}
        value={HITS_TYPES.VIDEO}
        selectedItem={selectedItem}
        handleSelect={refine}
        link={`${DEFAULT_DISCOVER_URL}/videos${searchQuery ? '?s=' + searchQuery : ''}`}
      />
      <TabItem
        data-testid="pathwaysTab"
        label={t('page.discover.pathways')}
        value={HITS_TYPES.PATHWAY}
        selectedItem={selectedItem}
        handleSelect={refine}
        link={`${DEFAULT_DISCOVER_URL}/pathways${searchQuery ? '?s=' + searchQuery : ''}`}
      />
      {hasNews && (
        <TabItem
          data-testid="newsTab"
          label={t('page.discover.text')}
          value={HITS_TYPES.NEWS}
          selectedItem={selectedItem}
          handleSelect={refine}
          link={`${DEFAULT_DISCOVER_URL}/insights${searchQuery ? '?s=' + searchQuery : ''}`}
        />
      )}
      <TabItem
        data-testid="glossaryTab"
        label={t('page.discover.glossary')}
        value={HITS_TYPES.GLOSSARY}
        selectedItem={selectedItem}
        handleSelect={refine}
        link={`${DEFAULT_DISCOVER_URL}/glossary${searchQuery ? '?s=' + searchQuery : ''}`}
      />
    </Wrapper>
  );
};

export default Tabs;

const Wrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  & div,
  & a {
    margin-right: ${SMALL_MARGIN_PX};

    &:last-child {
      margin-right: 0;
    }

    ${({ theme }) => theme.breakpoints.up('sm')} {
      margin-right: ${MIDDLE_MARGIN_PX};
    }
  }
`;
